{
  "de": {
    "actions": {
      "announcements": {
        "addPart": "Hinzufügen",
        "removePart": "Entfernen",
        "movePartUp": "Nach oben",
        "movePartDown": "Nach unten",
        "sendTest": "Test senden",
        "publish": "Senden",
        "retry": "Wiederholen",
        "refreshEngagement": "Zahlen aktualisieren",
        "openPost": "Beitrag öffnen"
      },
      "admin": {
        "dashboard": {
          "reloadModels": "Modelle neu laden",
          "reloadScData": "SC-Daten neu laden",
          "reloadPaints": "Lackierungen neu laden",
          "reloadModules": "Module neu laden",
          "reloadLoaners": "Leihschiffe neu laden"
        },
        "supporterContributions": {
          "syncFromPatreon": "Von Patreon synchronisieren"
        },
        "imports": {
          "loadAll": "Alles laden",
          "load": "Laden",
          "loadScData": "SC-Daten laden",
          "loadShipMatrix": "Ship Matrix laden",
          "cleanup": "Als fehlgeschlagen markieren",
          "cleanupSelected": "Auswahl als fehlgeschlagen markieren"
        }
      },
      "duplicate": "Duplizieren",
      "upgrade": "Update verfügbar!",
      "backToHome": "Neuen Kurs planen",
      "disableGrouping": "Gruppierung deaktivieren",
      "enableGrouping": "Gruppierung aktivieren",
      "groupedByModel": "Nach Modell gruppieren",
      "destroyAccount": "Konto löschen",
      "saveScreenshot": "Als PNG speichern",
      "resolve": "Auflösen",
      "sortBy": "Sortieren nach",
      "back": "Zurück",
      "open": "Öffnen",
      "copy": "Kopieren",
      "download": "Herunterladen",
      "zoom": "Zoom",
      "more": "Mehr...",
      "export": "Export",
      "exportHangarLink": "Export für hangar.link",
      "import": "Importieren",
      "here": "hier",
      "previous": "Zurück",
      "next": "Weiter",
      "cancel": "Abbrechen",
      "ok": "Ok",
      "reset": "Reset",
      "reload": "Neu Laden",
      "retry": "Erneut versuchen",
      "confirm": "Bestätigen",
      "showDetailPage": "Detailseite",
      "showDetails": "Details anzeigen",
      "hideDetails": "Details verbergen",
      "readMore": "Weiterlesen",
      "readLess": "Weniger anzeigen",
      "showGuide": "Guide anzeigen",
      "showFleetchart": "Flottenübersicht",
      "hideFleetchart": "Standardansicht",
      "fleetchartApp": {
        "useExtendedState": "Schiffe ausgefahren anzeigen",
        "useRetractedState": "Schiffe im Flug anzeigen"
      },
      "showLabels": "Labels anzeigen",
      "hideLabels": "Labels verbergen",
      "resetZoom": "Zoom zurücksetzen",
      "supportUs": "FleetYards.net unterstützen",
      "installApp": {
        "cta": "App installieren",
        "later": "Nicht jetzt"
      },
      "supportHint": {
        "cta": "FleetYards unterstützen",
        "later": "Vielleicht später"
      },
      "login": "Anmelden",
      "signUp": "Registrieren",
      "confirmAccess": "Passwort bestätigen",
      "sendConfirmAccessEmail": "Bestätigungs-E-Mail senden",
      "reset-password": "Passwort vergessen?",
      "edit": "Bearbeiten",
      "clear": "Löschen",
      "done": "Fertig",
      "share": "Teilen",
      "change": "Ändern",
      "upload": "Hochladen",
      "save": "Speichern",
      "enable": "Aktivieren",
      "disable": "Deaktivieren",
      "manage": "Verwalten",
      "enableGlobally": "Global aktivieren",
      "disableGlobally": "Global deaktivieren",
      "addActor": "Akteur hinzufügen",
      "addGroup": "Gruppe hinzufügen",
      "editGroup": "Gruppe bearbeiten",
      "remove": "Entfernen",
      "reorder": "Neu anordnen",
      "moveUp": "Nach oben",
      "moveDown": "Nach unten",
      "delete": "Löschen",
      "deleteSelected": "Ausgewählte löschen",
      "enableSelected": "Ausgewählte aktivieren",
      "disableSelected": "Ausgewählte deaktivieren",
      "presets": {
        "choose": "Bild auswählen",
        "remove": "Bild entfernen"
      },
      "close": "Schließen",
      "filter": "Filter",
      "showStatusColor": "Status als Farbe anzeigen",
      "hideStatusColor": "Status als Farbe ausblenden",
      "addToHangar": "Zum Hangar hinzufügen",
      "blueprint": {
        "own": "Als besessen markieren",
        "unown": "Markierung entfernen"
      },
      "resetFilter": "Filter zurücksetzen",
      "requestPassword": "Passwort-E-Mail anfordern",
      "changePassword": "Passwort ändern",
      "updatePassword": "Passwort aktualisieren",
      "copyBackupCodes": "Backup-Codes kopieren",
      "regenerate": "Neu generieren",
      "add": "Hinzufügen",
      "create": "Erstellen",
      "addToWishlist": "Zur Wunschliste hinzufügen",
      "addVehicle": "Schiffe hinzufügen",
      "showTableView": "Als Liste anzeigen",
      "showGridView": "Als Raster anzeigen",
      "linkExisting": "Vorhandenes verknüpfen",
      "loadMore": "Mehr laden",
      "unlink": "Verknüpfung aufheben",
      "syncRsiHangar": "RSI-Hangar synchronisieren",
      "oauthApplications": {
        "create": "Neue Anwendung",
        "regenerateSecret": "Schlüssel neu generieren",
        "approve": "Freigeben",
        "reject": "Ablehnen",
        "rejectSelected": "Auswahl ablehnen"
      },
      "oauthAuthorize": {
        "authorize": "Autorisieren",
        "deny": "Ablehnen"
      },
      "verifyWithCitizenId": "Mit Citizen iD verifizieren",
      "user": {
        "rsiVerification": {
          "verify": "Über RSI-Profil verifizieren",
          "check": "Jetzt prüfen",
          "checkIn": "Erneut prüfen in %{seconds} s",
          "copyToken": "Code kopieren",
          "regenerateToken": "Neuen Code erzeugen",
          "revoke": "Entziehen"
        }
      },
      "oauth": {
        "signInWith": "Anmelden mit",
        "google": "Google",
        "discord": "Discord",
        "bluesky": "BlueSky",
        "github": "GitHub",
        "twitch": "Twitch",
        "citizenid": "Citizen iD",
        "connected": {
          "google": "Mit Google verbunden",
          "discord": "Mit Discord verbunden",
          "bluesky": "Mit BlueSky verbunden",
          "github": "Mit GitHub verbunden",
          "twitch": "Mit Twitch verbunden",
          "citizenid": "Mit Citizen iD verbunden",
          "patreon": "Mit Patreon verbunden"
        },
        "disconnect": {
          "google": "Google trennen",
          "discord": "Discord trennen",
          "bluesky": "BlueSky trennen",
          "github": "GitHub trennen",
          "twitch": "Twitch trennen",
          "citizenid": "Citizen iD trennen",
          "patreon": "Patreon trennen"
        },
        "patreon": "Patreon"
      },
      "compare": {
        "ships": "Vergleichen"
      },
      "cargoGrids": {
        "addShips": "Schiffe hinzufügen"
      },
      "tradeRoutes": {
        "pickShip": "Schiff wählen",
        "changeShip": "Schiff wechseln",
        "editRun": "Bearbeiten",
        "doneEditing": "Fertig",
        "backToRuns": "Zurück zu allen Flügen",
        "showMore": "Weitere Flüge anzeigen"
      },
      "hangar": {
        "editGroups": "Gruppen hinzufügen oder löschen",
        "editName": "Benenne dein Schiff",
        "manageLoadouts": "Loadouts verwalten",
        "manageCargo": "Fracht verwalten",
        "useName": "Name verwenden",
        "destroyAll": "Alle Schiffe entfernen",
        "showOnPublicHangar": "Veröffentlichen",
        "hideFromPublicHangar": "Nicht öffentlich anzeigen",
        "editGroupsSelected": "Hinzufügen/Entfernen aus Gruppen",
        "resetIngame": {
          "openModal": "Ingame-Schiffe nach Wipe zurücksetzen",
          "moveToWishlist": "Zur Wunschliste verschieben",
          "removeAll": "Alle entfernen"
        }
      },
      "syncExtension": {
        "cancel": "Abbrechen",
        "start": "Synchronisation starten",
        "retry": "Synchronisierung wiederholen",
        "close": "Schließen",
        "refresh": "Seite aktualisieren"
      },
      "empty": {
        "hangarGuide": "Hilfe benötigt?",
        "reset": "Filter zurücksetzen"
      },
      "destroyFleet": "Flotte auflösen",
      "restore": "Wiederherstellen",
      "fleet": {
        "fidClaim": {
          "claim": "%{fid} beanspruchen",
          "withdraw": "Anspruch zurückziehen",
          "useSuggestion": "%{suggestion} verwenden",
          "endNow": "Schonfrist jetzt beenden",
          "cancel": "Anspruch abbrechen"
        },
        "rsiVerification": {
          "verify": "Verifizieren",
          "regenerateToken": "Neuen Code erzeugen",
          "check": "Jetzt prüfen",
          "copyToken": "Code kopieren",
          "revoke": "Entziehen"
        },
        "join": "%{fleet} beitreten!",
        "leave": "%{fleet} verlassen",
        "createInviteUrl": "Einladungs-Urls erstellen",
        "inviteMember": "Neues Mitglied einladen",
        "squadrons": {
          "create": "Staffel anlegen",
          "addMember": "Mitglieder hinzufügen",
          "removeMember": "Aus der Staffel entfernen",
          "addMembers": "%{count} hinzufügen",
          "viewMembers": "Mitglieder der Staffel",
          "viewShips": "Schiffe der Staffel",
          "viewStats": "Statistiken der Staffel",
          "join": "Team beitreten",
          "leave": "Verlassen",
          "requestJoin": "Beitritt anfragen",
          "withdrawRequest": "Anfrage zurückziehen",
          "acceptRequest": "Annehmen",
          "declineRequest": "Ablehnen",
          "promote": "Befördern",
          "demote": "Degradieren"
        },
        "manageInvites": "Einladungen",
        "worldmap": "Weltkarte",
        "starmap": "Sternenkarte",
        "acceptInvite": "Einladung annehmen",
        "declineInvite": "Einladung ablehnen",
        "acceptRequest": "Anfrage akzeptieren",
        "declineRequest": "Anfrage ablehnen",
        "members": {
          "invite": "Einladen",
          "promote": "Befördern",
          "demote": "Degradieren",
          "accept": "Akzeptieren",
          "decline": "Ablehnen",
          "remove": "Entfernen",
          "editRole": "Rolle bearbeiten",
          "editNickname": "Spitzname bearbeiten"
        },
        "inviteUrls": {
          "create": "Neue Einladungs-URL erstellen"
        },
        "discord": {
          "test": "Discord-Verbindung testen",
          "installBot": "Fleetyards-Bot auf deinem Discord-Server installieren"
        },
        "calendarSubscription": {
          "enable": "Abo-Link erzeugen",
          "rotate": "Link erneuern",
          "disable": "Abo deaktivieren"
        }
      },
      "model": {
        "gallery": "Galerie",
        "onSale": "Im Verkauf: %{price}",
        "store": "RSI-Seite"
      },
      "models": {
        "sync": "Von RSI synchronisieren",
        "syncMatrix": "Matrix synchronisieren",
        "syncScData": "SC-Daten synchronisieren",
        "importPaints": "Lackierungen importieren",
        "exchangeStoreImage": "RSI-Bild verwenden",
        "images": "Bilder",
        "openTableConfiguration": "Tabellenkonfiguration öffnen"
      },
      "users": {
        "loginAs": "Als Benutzer anmelden",
        "resendConfirmation": "Bestätigung erneut senden",
        "sendPasswordReset": "Passwort-Zurücksetzung senden"
      },
      "unselect": "Auswahl aufheben",
      "twoFactor": {
        "enable": "Zwei-Faktor aktivieren",
        "disable": "Zwei-Faktor deaktivieren",
        "generateBackupCodes": "Backup-Codes generieren"
      },
      "holoViewer": {
        "autoRotate": {
          "enable": "Auto-Drehung aktivieren",
          "disable": "Auto-Drehung deaktivieren"
        },
        "zoom": {
          "enable": "Zoom aktivieren",
          "disable": "Zoom deaktivieren"
        },
        "color": {
          "enable": "Farben aktivieren",
          "disable": "Farben deaktivieren"
        }
      },
      "logistics": {
        "createInventory": "New Inventory",
        "submit": "Submit",
        "reject": "Reject",
        "cancel": "Cancel",
        "deposit": "Deposit",
        "withdraw": "Withdraw",
        "createItem": "Add Item",
        "importCsv": "Import CSV",
        "downloadTemplate": "Download Template",
        "destroyEntry": "Delete Entry",
        "editStockItem": "Edit Item",
        "destroyStockItem": "Delete Item",
        "editInventory": "Edit Inventory",
        "clearCargo": "Fracht leeren",
        "viewCargoGrid": "Frachtraster ansehen",
        "sendTransfer": "Senden",
        "moveStock": "Verschieben",
        "transfer": "Transfer",
        "acceptTransfer": "Annehmen",
        "declineTransfer": "Ablehnen",
        "cancelTransfer": "Zurückziehen",
        "reportTransfer": "Melden",
        "resetToMax": "Auf Maximum zurücksetzen",
        "removeLine": "Entfernen"
      },
      "adminNotifications": {
        "unread": "Als ungelesen markieren",
        "archive": "Archivieren",
        "unarchive": "Zurück in den Posteingang",
        "readAll": "Alle als gelesen markieren",
        "destroyAll": "Alle löschen",
        "sortOldest": "Älteste zuerst",
        "sortNewest": "Neueste zuerst",
        "select": "Benachrichtigung auswählen",
        "readSelected": "Auswahl als gelesen markieren",
        "unreadSelected": "Auswahl als ungelesen markieren",
        "archiveSelected": "Auswahl archivieren",
        "unarchiveSelected": "Auswahl zurück in den Posteingang",
        "destroySelected": "Auswahl löschen"
      },
      "account": {
        "calendarSubscription": {
          "enable": "Persönlichen Kalenderlink erzeugen",
          "rotate": "Link erneuern",
          "disable": "Abo deaktivieren"
        }
      },
      "today": "Heute",
      "fleets": {
        "missions": {
          "publish": "Veröffentlichen",
          "create": "Mission erstellen",
          "edit": "Mission bearbeiten",
          "archive": "Mission archivieren",
          "unarchive": "Wiederherstellen",
          "destroy": "Endgültig löschen",
          "addTeam": "Team hinzufügen",
          "addShip": "Schiff hinzufügen",
          "addSlot": "Slot hinzufügen",
          "viewMissions": "Missionen anzeigen"
        },
        "tours": {
          "viewTours": "Touren ansehen"
        },
        "events": {
          "create": "Event erstellen",
          "edit": "Event bearbeiten",
          "spawn": "Aus dieser Mission erstellen",
          "archive": "Event archivieren",
          "unarchive": "Aus dem Archiv wiederherstellen",
          "syncToDiscord": "Mit Discord synchronisieren",
          "destroy": "Endgültig löschen",
          "publish": "Veröffentlichen",
          "lockSignups": "Anmeldungen sperren",
          "unlockSignups": "Anmeldungen freigeben",
          "start": "Starten",
          "complete": "Abschließen",
          "cancel": "Absagen",
          "signup": "Anmelden",
          "withdraw": "Abmelden",
          "kick": "Anmeldung entfernen",
          "addToCalendar": "Zum Kalender hinzufügen",
          "subscribe": "Abonnieren",
          "setUpCalendar": "Kalender-Abos einrichten",
          "assignSlot": "Slot zuweisen",
          "reassignSlot": "In anderen Slot verschieben",
          "manageEventTeam": "Event-Team verwalten",
          "grantRole": "Rolle vergeben",
          "revokeRole": "Entziehen",
          "addTeam": "Team hinzufügen"
        },
        "contracts": {
          "create": "Auftrag erstellen",
          "save": "Auftrag speichern",
          "publish": "Veröffentlichen",
          "claim": "Übernehmen",
          "join": "Mitmachen",
          "release": "Abgeben",
          "fulfil": "Als erfüllt markieren",
          "cancel": "Auftrag abbrechen",
          "edit": "Bearbeiten",
          "leave": "Verlassen",
          "remove": "Entfernen",
          "acceptCrew": "Annehmen",
          "declineCrew": "Ablehnen",
          "addItem": "Waren hinzufügen",
          "payouts": "Auszahlung"
        }
      },
      "notifications": {
        "unread": "Als ungelesen markieren",
        "archive": "Archivieren",
        "unarchive": "Zurück in den Posteingang",
        "readAll": "Alle als gelesen markieren",
        "destroyAll": "Alle löschen",
        "settings": "Benachrichtigungseinstellungen",
        "sortOldest": "Älteste zuerst",
        "sortNewest": "Neueste zuerst",
        "openCenter": "Benachrichtigungen",
        "pushEnable": "Für dieses Gerät aktivieren",
        "pushDisable": "Für dieses Gerät deaktivieren",
        "pushRemove": "Entfernen",
        "select": "Benachrichtigung auswählen",
        "readSelected": "Auswahl als gelesen markieren",
        "unreadSelected": "Auswahl als ungelesen markieren",
        "archiveSelected": "Auswahl archivieren",
        "unarchiveSelected": "Auswahl zurück in den Posteingang",
        "destroySelected": "Auswahl löschen"
      },
      "unlistedModel": {
        "createModel": "Schiff anlegen",
        "markAsPaint": "Ist eine Lackierung",
        "ignore": "Ignorieren",
        "noManufacturer": "Zu diesem Identifier lässt sich kein Hersteller auflösen",
        "alreadyExists": "%{name} ist bereits im Katalog",
        "link": "Schon im Katalog",
        "markAsPaintSelected": "Auswahl als Lackierungen markieren",
        "ignoreSelected": "Auswahl ignorieren"
      },
      "revert": "Zurücksetzen",
      "exportCsv": "CSV exportieren",
      "exportAllCsv": "Alles als CSV exportieren",
      "imports": {
        "cancel": "Abbrechen",
        "downloadExample": "Beispieldatei",
        "toggleDetails": "Details anzeigen"
      },
      "selectFile": "Datei auswählen",
      "applyGameFileValue": "Übernehmen",
      "applyAllGameFileValues": "Alle übernehmen",
      "payouts": {
        "archiveTour": "Archivieren",
        "unarchiveTour": "Wiederherstellen",
        "deleteTour": "Löschen",
        "openLedger": "Auszahlungsbuch öffnen",
        "addEntry": "Geld erfassen",
        "addParticipant": "Teilnehmer hinzufügen",
        "settle": "Abrechnen & Auszahlungen berechnen",
        "reopen": "Wieder öffnen",
        "confirm": "Als bezahlt markieren",
        "unconfirm": "Als unbezahlt markieren",
        "createTour": "Tour erstellen",
        "joinTour": "Tour beitreten",
        "rotateInvite": "Neuen Link erzeugen",
        "askToJoin": "Teilnahme anfragen",
        "withdrawJoinRequest": "Anfrage zurückziehen",
        "approveJoinRequest": "Annehmen",
        "declineJoinRequest": "Ablehnen",
        "approveExpense": "Freigeben",
        "declineExpense": "Ablehnen"
      },
      "relationships": {
        "accept": "Annehmen",
        "decline": "Ablehnen",
        "ignore": "Ignorieren",
        "withdraw": "Zurückziehen",
        "end": "Entfernen",
        "send": "Anfrage senden",
        "user": {
          "add": "Freund hinzufügen"
        },
        "fleet": {
          "add": "Verbündeten hinzufügen"
        }
      },
      "supporterNomination": {
        "change": "Flotte ändern"
      }
    }
  }
}
